import NotFoundRoutes from "../pages/404/notfound.routes";
import CheckoutPageRoutes from "../pages/checkout/checkout.routes";
import { explorerRoutes } from "../pages/explorer/explorer.routes";
import SettingsRoutes from "../pages/settings/setting.routes";
import OrderPlacedRoutes from "../pages/success/suscess.routes";
import WelcomeRoutes from "../pages/welcome/welcome.routes";


const routesConfig = [
    WelcomeRoutes,
    SettingsRoutes,
    CheckoutPageRoutes,
    NotFoundRoutes,
    OrderPlacedRoutes,
    explorerRoutes
];

export default routesConfig;
